/**
 * Planning Nav Menu (Epic C-5 — Mijn indeling & navigatie, Story C-5.2, UX-Nav)
 *
 * Eén "Planning"-ingang in de hoofdnavigatie met vier tabs: Planbord
 * (default) · Bezetting · Taken · Kwalificaties. Klikken op "Planning" zelf
 * navigeert direct naar Planbord (AC 1 "default-tab"); het chevron-icoontje
 * opent een klein submenu met de overige drie tabs. Bewust GEEN vijfde
 * "Conflicten"-tab (C-4.3/C-5 UX-besluit: conflicten zijn een
 * banner+paneel+dashboard-tegel, geen eigen bestemming).
 *
 * Zelfde hand-rolled dropdown-patroon (state + click-outside) als de
 * bestaande user-avatar-dropdown in `Layout.tsx` — geen shadcn/Radix.
 */

import { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const PLANNING_SUBTABS = [
  { label: 'Bezetting', to: '/planning/bezetting' },
  { label: 'Taken', to: '/planning/taken' },
  { label: 'Kwalificaties', to: '/planning/kwalificaties' },
] as const;

export function PlanningNavMenu() {
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <div className="relative flex items-center" ref={ref}>
      <Link to="/planning/planbord" className="text-gray-600 hover:text-gray-900 px-3 py-2 text-sm font-medium">
        Planning
      </Link>
      <button
        type="button"
        onClick={() => setOpen((prev) => !prev)}
        aria-label="Overige Planning-tabs tonen"
        aria-expanded={open}
        data-testid="planning-nav-toggle"
        className="text-gray-400 hover:text-gray-600 -ml-2 mr-1 p-0.5"
      >
        <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24" aria-hidden="true">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </button>

      {open && (
        <div className="absolute left-0 top-full mt-1 w-48 bg-white rounded-md shadow-lg ring-1 ring-gray-200 z-50 py-1">
          {PLANNING_SUBTABS.map((tab) => (
            <Link
              key={tab.to}
              to={tab.to}
              onClick={() => setOpen(false)}
              className="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100"
            >
              {tab.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
